export default __webpack_public_path__ + "static/media/PerfNo2Open.ec47f678.jpg";